module.exports = __webpack_public_path__ + "4b6ff4cfc726efd9886970f7abb84313.mp4";